import Radar from "@mui/icons-material/Radar";

import { makeSvgIcon } from "./svg-icon";

export const RadarIcon = makeSvgIcon(Radar);

export default RadarIcon;
